import { IOffer } from '../repositories/search-offers.legacy/v2/types';

import { getAgentLevelInfo } from './getAgentLevelInfo';

export function showAgentLevel(offer: IOffer): boolean {
  const userLevelInfo = getAgentLevelInfo(offer);

  return typeof userLevelInfo?.levelOrder === 'number' && userLevelInfo.levelOrder >= 3;
}
